import React, { useState } from 'react';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import './SignupStep.css';
import DynamicForm from '../../components/dynamicForm';
import { signupStep1Schema } from '../../formData/signupStep1';
import { useNavigate } from 'react-router-dom'

export default function SignupStep1() {
    const navigate = useNavigate()
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({})

    const handleAction = (action, data) => {

        setFormData(prev => ({ ...prev, ...data }))

        console.log('ACTION:', action, 'DATA:', data);
        if (action === 'next') {
            navigate('/signup/step-2', { state: { ...formData, ...data } })
        }
    };

    return (
        <div className="signup-page">
            <Header />
            <div className="signup-content">
                <Sidebar activeStep={1} />
                <main className="signup-main">
                    <div className='centered-alight-login-signup-comp'>
                        <div className='formTitle'>Contact &amp; Login Details</div>
                        <p className="signup-desc">
                            Enter your contact and login details below to get started.
                        </p>
                            
                        <DynamicForm schema={signupStep1Schema} onAction={handleAction} />

                        <p className="login-prompt">
                            Already have an account? <a href="/login">Log In</a>
                        </p>
                    </div>
                </main>
            </div>
        </div>
    );
}
